import { lazy } from 'react';

const OutgoingInvoices = lazy(() => import('./OutgoingInvoices'));

export default OutgoingInvoices;
